import { TArticleDetail } from 'shared/models/article';
import { PromiseOrValue } from 'shared/utils/promise-or-value';
import { atom } from 'jotai';
import { safeAtomFamily } from 'shared/utils/safe-atom-family';
import { Unreachable } from '@lemon8/web-app-shared/util';

export enum ERelatedChannel {
  FeedForyou = '0',
  Related = '61',
  VerticalSearch = 'vertical_search',
}

export interface IArticleRelatedPosts {
  items: TArticleDetail[];
  relatedChannel: ERelatedChannel;
  hasMore: boolean;
  sessionImprId: string;
  maxBehotTime: string;
  searchId: string;
  maxCursor: string;
}

type TArticleRelatedPostsStore = { [key: string]: PromiseOrValue<IArticleRelatedPosts> | undefined };

const $ArticleRelatedPostsStore = atom({} as TArticleRelatedPostsStore);
$ArticleRelatedPostsStore.debugLabel = '$ArticleRelatedPostsStore';

export const $ArticleRelatedPosts = safeAtomFamily((groupId: string) => {
  const a = atom<PromiseOrValue<IArticleRelatedPosts>, [PromiseOrValue<IArticleRelatedPosts>], void>(
    (get) => {
      const data = get($ArticleRelatedPostsStore)[groupId];
      if (!data) {
        return Unreachable();
      }

      if (data instanceof Promise) {
        return data.catch(() => ({
          items: [],
          relatedChannel: ERelatedChannel.Related,
          hasMore: false,
          sessionImprId: '',
          maxBehotTime: '',
          searchId: '',
          maxCursor: '',
        }));
      }

      return data;
    },
    (get, set, input: PromiseOrValue<IArticleRelatedPosts>) => {
      const old = get($ArticleRelatedPostsStore);
      set($ArticleRelatedPostsStore, { ...old, [groupId]: input });
    },
  );

  a.debugLabel = `$ArticleRelatedPosts+${encodeURIComponent(groupId)}`;
  return a;
});

export const $ArticleRelatedPostsLoadmore = safeAtomFamily((groupId: string) => {
  const a = atom(null, async (get, set, input: IArticleRelatedPosts) => {
    const store = get($ArticleRelatedPostsStore);
    const old = await store[groupId];

    if (old) {
      set($ArticleRelatedPostsStore, {
        ...store,
        [groupId]: {
          ...input,
          items: [...old.items, ...input.items],
        },
      });
    }
  });

  a.debugLabel = `$ArticleRelatedPostsLoadmore+${encodeURIComponent(groupId)}`;
  return a;
});
